module.exports = __webpack_public_path__ + "img/araucaria.bc547df7.svg";